/**
 * Component Registry for Mox Theme
 * 
 * Extends the base prestige theme registry with Mox specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-prestige/registry';
import { Header } from './components/Header';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { FAQList } from './components/FAQList';
import { SitemapContent } from './components/SitemapContent';

/**
 * Mox specific component overrides.
 * These components have been customized for the Mox brand.
 *
 * Example:
 * import { Footer } from './components/Footer';
 *
 * const moxOverrides: Partial<ComponentRegistry> = {
 *   Footer,
 * };
 */
const moxOverrides: Partial<ComponentRegistry> = {
  Header,
  ScheduleTourForm,
  FAQList,
  SitemapContent,
};

/**
 * Final merged registry for Mox properties.
 * Inherits all components from the prestige theme, with Mox overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...moxOverrides,
};

export default registry;
